import { Avatar, Button, Grid2, Menu, MenuItem, Typography, Tabs, Tab } from '@mui/material'
import React, { useContext, useEffect, useState, useMemo } from 'react'
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import logoLyor from '../images/Lyor.jpg'
import logoGrupo from '../images/logo_grupo.png'
import '../css/Layout/Layout.css'
import AutorenewIcon from '@mui/icons-material/Autorenew';
import LogoutIcon from '@mui/icons-material/Logout';
import axios from 'axios'
import { GrCube } from "react-icons/gr";
import Main from "./Main";
import MainEstoqueGarantido from './MainEstoqueGarantido';
import MainCTA from './MainCTA';
import GeracaoFotos from './GeracaoFotos';
import LaminasComerciais from './LaminasComerciais';
import ImagensAmazon from './ImagensAmazon';
import SessionContext from '../Context/SessionContext';

const gruposComAcessoAmazon = new Set([
  'Geradora-Grandes-Ecommerces',
  'Espelho - Admin',
  'Espelho - Diretoria',
]);

const Layout = () => {
  const { session } = useContext(SessionContext);
  const codEmp = Number(localStorage.getItem("empresa"))
  const nmRep = String(localStorage.getItem('nmRep'))
  const loginType = localStorage.getItem('loginType')

  // Memoriza se é cliente para evitar recalcular e causar re-renders
  const isCliente = useMemo(() => loginType === 'cliente', [loginType]);
  const podeAcessarAmazon = loginType === 'azure' &&
    session.groups?.some(group => gruposComAcessoAmazon.has(group.displayName));

  const [photo, setPhoto] = useState('')
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // Estado inicial limpo e direto
  const [tabValue, setTabValue] = useState<string>(isCliente ? 'fotos' : 'padrao');

  // Força a aba correta APENAS se o perfil mudar de fato, sem escutar o tabValue
  useEffect(() => {
    if (isCliente) {
      setTabValue('fotos');
    } else {
      setTabValue('padrao');
    }
  }, [isCliente]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    const loginType = localStorage.getItem('loginType');
    const empresa = localStorage.getItem("empresa") || '';

    localStorage.clear();
    localStorage.setItem("empresa", empresa);

    if (loginType === 'cliente') {
      window.location.href = '/login?logout=true';
      return;
    }

    const loginApi = process.env.REACT_APP_LOGIN_API;
    const frontUrl = process.env.REACT_APP_FRONT_URL;

    const url = `${loginApi}/signout?redirectTo=${frontUrl}/login?logout=true`;

    window.location.href = url;
  };

  const parse_namespace = (name_space: string) =>
    name_space.length >= 14 ? `${name_space.substring(0, 14)}` : name_space;

  // Busca foto de perfil
  useEffect(() => {
    const url = localStorage.getItem('profileBase64')
    if (!url) {
      setPhoto('')
      return
    }

    axios({
      url,
      responseType: 'blob'
    }).then((res: any) => {
      let src = window.URL.createObjectURL(res.data);
      setPhoto(src)
    })
  }, [])

  return (
    <Grid2>
      <Grid2>
        <AppBar position="fixed" className='header' sx={{ background: '#fff', color: '#1a3661' }}>
          <Container maxWidth={false}>
            <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <GrCube color='#1a3661' size={32} />
                <Typography
                  sx={{
                    fontSize: '15pt',
                    fontWeight: 'bold',
                    color: '#1a3661',
                    paddingLeft: '8px'
                  }}>
                  Geradora de Produtos
                </Typography>
              </div>

              <img src={logoGrupo}
                alt="Logo"
                className='logoImgGrupo'
              />
              <div
                className='group-image-portal'
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  backgroundColor: '#eaeaea',
                  borderRadius: '60px'
                }}
              >
                <Typography
                  variant='h5'
                  className='name-space-header'
                  sx={{
                    fontSize: '11pt',
                    textTransform: 'uppercase',
                    color: '#000',
                    lineHeight: '6px',
                    paddingLeft: '16px',
                    fontWeight: 'bold',
                  }}
                >
                  {parse_namespace(nmRep)}
                </Typography>
                <Button
                  aria-controls='customized-menu'
                  aria-haspopup='true'
                  variant='contained'
                  onClick={handleClick}
                  style={{
                    color: 'transparent',
                    background: 'transparent',
                    border: 'none',
                    boxShadow: 'none'
                  }}
                >
                  <Avatar src={photo} />
                </Button>
              </div>

              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      padding: '0',
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      '&::before': { display: 'none' },
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem onClick={handleLogout} className='itemMenu'>
                  <LogoutIcon /> Sair
                </MenuItem>
              </Menu>
            </Toolbar>

            {/* Componente Tabs controlado estritamente pelo tabValue */}
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              sx={{ paddingLeft: "16px" }}
            >
              {!isCliente && <Tab value="padrao" label="Padrão" />}
              {!isCliente && <Tab value="estoque" label="Estoque Garantido" />}
              {!isCliente && <Tab value="cadastro" label="Cadastro Produto" />}
              <Tab value="fotos" label="Geração de Fotos" />
              {!isCliente && <Tab value="laminas" label="Lâminas comerciais" />}
              {podeAcessarAmazon && <Tab value="amazon" label="Imagens Amazon Vendor" />}
            </Tabs>
          </Container>
        </AppBar>
      </Grid2>

      {/* Margem superior para o conteúdo não sumir atrás do AppBar fixed */}
      <div style={{ marginTop: '140px', padding: '20px' }}>
        {tabValue === 'padrao' && !isCliente && <Main />}
        {tabValue === 'estoque' && !isCliente && <MainEstoqueGarantido />}
        {tabValue === 'cadastro' && !isCliente && <MainCTA />}
        {tabValue === 'fotos' && <GeracaoFotos />}
        {tabValue === 'laminas' && !isCliente && <LaminasComerciais />}
        {tabValue === 'amazon' && podeAcessarAmazon && <ImagensAmazon />}
      </div>
    </Grid2>
  )
}

export default Layout;
